import { useMutation, useQueryClient } from '@tanstack/react-query';
import { HeapRecordingService, UpdateHeapRecordingDTO } from '../../generated';
import { heapRecordingFilterOptionsKeys } from '../../queries/heapRecordingFilterOptions';
import { heapRecordingKeys } from '../../queries/heapRecordingList';

interface UpdateHeapRecordingBatchProps {
  jobsiteId: string;
  batchId: string;
  update: Partial<UpdateHeapRecordingDTO>;
}

// update every camera in a batch via a single backend call so archiving/unarchiving a multi-camera batch can't
// partially fail
export function useUpdateHeapRecordingBatch() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ jobsiteId, batchId, update }: UpdateHeapRecordingBatchProps) => {
      const response = await HeapRecordingService.heapRecordingControllerUpdateRecordingBatch({
        path: { jobsiteId, batchId },
        body: update,
      });
      if (response.error) throw Error();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: heapRecordingKeys.base() });
      queryClient.invalidateQueries({ queryKey: heapRecordingFilterOptionsKeys.base() });
    },
  });
}
